import RestService from './RestService';
import NotificationTargetsService from './NotificationTargetsService';

class NotificationsStatusService extends RestService {
    constructor(parentService) {
        if (parentService) {
            super(`${parentService.baseUrl}/status`);
        } else throw new Error('Can be only nested service');
    }
}

export default class NotificationsService extends RestService {
    constructor(parentService, parentId) {
        if (parentService && parentId) {
            super(`${parentService.baseUrl}/${parentId}/notifications`);
        } else super('/notifications');
    }

    targetsService(reasonId) {
        return new NotificationTargetsService(this, reasonId);
    }

    sendEmail(reasonId, email) {
        return this.post(`${this.baseUrl}/${reasonId}/sendEmail`, { email });
    }

    /**
     * Download a file from notification context by S3 URL. Returns full response (with responseType blob).
     */
    downloadFile(reasonId, s3Url, options = {}) {
        const url = `${this.baseUrl}/${reasonId}/download`;
        return this.get(url, { url: s3Url }, { responseType: 'blob', ...options });
    }

    statusService() {
        return new NotificationsStatusService(this);
    }
}
